<template>
  <div class="fill-progress">
    <div class="fill-progress__step">
      <span class="fill-progress__icon">
        <BaseCircularLoadingBar :size="16" :width="2" />
      </span>
      <span class="fill-progress__text">{{ stepLabel }}</span>
      <span v-if="total" class="fill-progress__count">
        {{ $tc('page.opportunity-forms.fill-progress', completed, { completed, total }) }}
      </span>
    </div>
  </div>
</template>

<script>
import BaseCircularLoadingBar from '@/components/base/BaseCircularLoadingBar.vue';

export default {
  name: 'FillProgress',
  components: { BaseCircularLoadingBar },
  props: {
    completed: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    step: {
      type: String,
      default: null,
    },
  },
  computed: {
    stepLabel() {
      const key = `page.opportunity-forms.fill-steps.${this.step}`;
      return this.step && this.$te(key) ? this.$t(key) : this.$t('page.opportunity-forms.fill-steps.filling_forms');
    },
  },
};
</script>

<style lang="scss">
.fill-progress {
  display: flex;
  flex-direction: column;
  gap: $space-1;
  min-width: 180px;

  &__step {
    display: flex;
    align-items: center;
    gap: $space-sm;
    @include text-style('label-md');
    color: $color-text-muted;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  &__count {
    @include text-style('label-md');
    color: $color-text-ai;
    font-variant-numeric: $font-variant-tabular;
  }
}
</style>
